module.exports = __webpack_public_path__ + "img/start_ban.png";